import angular from 'angular';
import dragdrop from 'angular-native-dragdrop';

import ComponentModule from './component';
import CalendarDayComponent from './calendar-day.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-day', [
        dragdrop,

        ComponentModule.name
    ])
    .component(CalendarDayComponent.selector, CalendarDayComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-day/index.js